controllers.controller('ExternalController', [
    '$scope', '$state', '$filter', '$timeout', '$ionicLoading', '$q', '$sce',
    'LocaleService', 'config', 'Validator', 'Storage', 'constants', 'ServerTimeService', 'Utils', 'UserService', 'API', 'ErrorService',
    function ($scope, $state, $filter, $timeout, $ionicLoading, $q, $sce, LocaleService, config, Validator, Storage, Const,
              ServerTimeService, Utils, UserService, API, ErrorService) {

        LocaleService.wait().then(function (translation) {
            $scope.translation = translation;
        });

        self.iframeEl = null;
        $scope.user = UserService.get();
        $scope.paymentMethods = Storage.get('paymentMethods') || [];
        $scope.lang = LocaleService.lang;
        $scope.methodName = $state.params.method.name || '';
        $scope.iframeUrl = $sce.trustAsResourceUrl($state.params.method.url + '?lang=' + $scope.lang);
        $ionicLoading.show();

        
        $scope.modal = {
            actionText: LocaleService.translation.try_again,
            state: false
        };

        $scope.iframeLoad = function () {
            $ionicLoading.hide();
            $scope.iframeReady = true;
        };

        $scope.iframeLoadFail = function () {
            $ionicLoading.hide();
            $scope.iframeReady = false;
            $scope.iframeUrl = $sce.trustAsResourceUrl('about:blank');

            $scope.modal.isError = true;
            $scope.modal.textTitle = LocaleService.translation.messages.general_error;
            $scope.modal.textContent = LocaleService.translation.messages.general_error_text;
            $scope.modal.actionText = $scope.paymentMethods.length > 1 ? LocaleService.translation.try_again : LocaleService.translation.close;
            $scope.modal.back = $scope.paymentMethods.length > 1 ? 'root.app.wallet' : 'root.app.assets';
            $scope.modal.state = true;
        };


        function clear() {
            $scope.iframeReady = false;
            $scope.iframeUrl = $sce.trustAsResourceUrl('about:blank');
            $scope.user = null;
        }

        $scope.$on('$ionicView.afterLeave', clear);
        $scope.$on('clear', clear);
    }
]);
